<template>
  <div class="c-main-header">
    <div class="c-main-header__row">
      <div class="c-main-header__right">
        <h2 class="c-main-header__logo">
          <i :class="logoClasses"/>
          <!-- <span
            v-show="$vuetify.breakpoint.mdAndUp"
          >
            <span
              class="text-h6 font-family-poppins middle"
            >
              CoroPrevention
            </span>
            <span
              style="display: block; font-size: 14px; font-weight: 400"
              class="font-family-poppins middle"
            >
              0.0.1 - Alpha
            </span>
          </span> -->
        </h2>
        <div class="c-main-header__title">
          <h3
            v-for="(id, i) in siteIds"
            :key="id"
            class="mr-2"
          >
            {{ id }} {{ i !== siteIds.length-1 ? '/' : ''}}
          </h3>
        </div>
        <general-patient-search
          class="c-main-header__search-patients"
          v-if="standardDashboardUser && $vuetify.breakpoint.mdAndUp"
        />
      </div>
      <div class="c-main-header__left">
        <menu class="c-main-header__menu">
          <v-tooltip bottom  v-if="$vuetify.breakpoint.smAndDown">
            <template v-slot:activator="{ on, attrs }">
              <li
                v-on="on"
                v-bind="attrs"
              >
                <a
                  class="text-link-menu"
                  @click="switchMobileSearch"
                >
                  <eva-icon name="search-outline"/>
                </a>
              </li>
            </template>
            {{ $ucfirst($t('patient.search')) }}
          </v-tooltip>
          <v-tooltip bottom v-if="showIcons()">
            <template v-slot:activator="{ on, attrs }">
              <li
                v-on="on"
                v-bind="attrs"
              >
                <router-link class="text-link-menu" :to="{ name : 'Alerts' }">
                  <eva-icon name="bell-outline"/>
                  <span class="c-main-header__menu-alert-count">{{ redAndOrangeCount }}</span>
                </router-link>
              </li>
            </template>
            {{ $ucfirst($t('patient.alerts')) }}
          </v-tooltip>
          <v-tooltip bottom v-if="showIcons()">
            <template v-slot:activator="{ on, attrs }">
              <li
                v-on="on"
                v-bind="attrs"
              >
                <router-link class="text-link-menu" :to="{ name : 'PatientList' }">
                  <eva-icon name="people-outline"/>
                </router-link>
              </li>
            </template>
            {{ $ucfirst($t('patient.allpatients')) }}
          </v-tooltip>
          <v-tooltip bottom v-if="showIcons()">
            <template v-slot:activator="{ on, attrs }">
              <li
                v-on="on"
                v-bind="attrs"
              >
                <router-link class="text-link-menu" :to="{ name : 'PatientCreate' }">
                  <eva-icon name="person-add-outline"/>
                </router-link>
              </li>
            </template>
            {{ $ucfirst($t('patient.create')) }}
          </v-tooltip>
        </menu>
        <MenuButton
          class="c-main-header__menu-btn"
          :button-title="$app.user.getUserFullName()"
          :items="accountItems"
        />
      </div>
    </div>
    <div
      class="c-main-header__row"
      v-if="$vuetify.breakpoint.smAndDown && isMobileSearchActive"
    >
      <general-patient-search
        class="c-main-header__search-patients"
        v-if="standardDashboardUser && ($vuetify.breakpoint.mdAndUp || isMobileSearchActive)"
      />
    </div>

    <v-dialog
      width="600px"
      v-model="showPendingAlertDialog"
    >
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{ $ucfirst($t('login.logoutWithPendingAlerts')) }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <v-btn
            x-large
            text
            class="ml-4"
            @click="doLogout"
          >
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn
            x-large
            text
            class="ml-4"
            @click="showPendingAlertDialog = false"
            color="primary"
          >
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>

import MenuButton from "./MenuButton"
import GeneralPatientSearch from "../Patient/GeneralPatientSearch";
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import {getAlerts as getAlertsQuery} from "../../../store/alerts/queries";

/**
 * Component MainHeader.vue
 *
 * @module MainHeader
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/MainHeader.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MainHeader',
  components: {
    GeneralPatientSearch,
    MenuButton
  },
  data() {
    return {
      isMobileSearchActive: false,
      accountItems: [],
      showPendingAlertDialog: false,
      siteIds: [],
      redAndOrangeCount: 0,
      pendingAlerts: 0,
    };
  },
  methods: {
    async fetchRedAndOrangePendingCount() {
      if (!this.standardDashboardUser) {
        return 0;
      }

      const {data} = await this.$app.apolloClient.query({
        query: getAlertsQuery,
        variables: {
          limit: 1,
          offset: 0,
          orders : [],
          conditions: {
            gate: 'and',
            inputs: [
              { field: 'state', operator: 'in', parameters: ['active'] },
              { field: 'emergencyLevel', operator: 'in', parameters: ["2", "3"] }
            ],
          },
          functions: []
        },
      });

      if (data?.alerts?.count) {
        return data.alerts.count;
      } else {
        return 0;
      }
    },
    async fetchPendingAlertsCount() {
      if (!this.standardDashboardUser) {
        return 0;
      }

      const {data} = await this.$app.apolloClient.query({
        query: getAlertsQuery,
        variables: {
          limit: 1,
          offset: 0,
          orders : [],
          conditions: {
            gate: 'and',
            inputs: [
              { field: 'state', operator: 'in', parameters: ['active'] },
              { field: 'emergencyLevel', operator: 'in', parameters: ["1","2", "3"] }
            ],
          },
          functions: []
        },
      });

      if (data?.alerts?.count) {
        return data.alerts.count;
      } else {
        return 0;
      }
    },
    refresh() {
       // When language changes in the languagepicker for some reason this component does not update its languages
       // work around for redrawing the account items with the correct translations.
       this.accountItems = [];

       setTimeout(() => {
         this.setAccountItems();
       }, 1000)
    },
    setAccountItems() {
      this.accountItems = [];

      if (this.standardDashboardUser) {
        this.accountItems.push({
          title: this.$ucfirst(
              this.$t('screens.settingsScreen', { catalog: 'app_mobile' })
          ),
          listeners: {
            click: (e) => {
              e.preventDefault();
              this.$router.push({ name: 'Settings' });
            }
          }
        },
        {
          title: this.$ucfirst(
              this.$t('screens.aboutScreen', { catalog: 'app_mobile' })
          ),
          listeners: {
            click: (e) => {
              e.preventDefault();
              this.$router.push({ name: 'About' });
            }
          }
        });
      }

      this.accountItems.push(
          {
            title: this.$ucfirst(this.$t('login.logout')),
            listeners: {
              click: async (e) => {
                e.preventDefault();

                const unsaved = this.anyUnsavedChanges;
                const pendingAlerts = await this.fetchPendingAlertsCount();

                if (unsaved) {
                  this.$app.eventBus.$emit('unsavedChangesBeforeLogout');
                  return;
                }

                if (pendingAlerts) {
                  this.showPendingAlertDialog = true;
                  return;
                }

                this.doLogout();
              }
            }
          }
      );
    },
    switchMobileSearch() {
      this.isMobileSearchActive = !this.isMobileSearchActive;
    },
    doLogout() {
      this.$app.authentication.logout().then(() => {
        this.$toasted.show(this.$ucfirst(this.$t('login.loggedout')))
        this.$router.push({ name: 'Login' })
      })
    },
    showIcons() {
      const currentRoute = this.$route.name
      const enabledOn = ['Alerts', 'PatientList', 'PatientCreate', 'PatientOverview']
      return enabledOn.includes(currentRoute)
    },
    getSiteIds() {
      if (!this.standardDashboardUser) {
        return [];
      }

      this.$app.apolloMobileClient
        .query({
          query: gql`{
            myUser {
              managedSites{
                siteKey
                siteTitle
              }
            }
          }`,
        })
        .then((result) => {
          if (!result.data?.myUser) return;
          this.siteIds = result.data.myUser.managedSites.map(item => item.siteKey);
        });
    }
  },
  computed: {
    ...mapGetters({
      anyUnsavedChanges: 'patientSummary/anyUnsavedChanges',
    }),
    standardDashboardUser() {
      return this.$store.getters["user/isStandardDashboardUser"];
    },
    logoClasses() {
      const classes = [
        'c-main-header__icon',
        'icon-coro',
        'icon-coro--responsive',
      ]

      if (!this.$store.getters['isTestingEnvironment']) {
        classes.push('icon-coro--prod');
      }

      return classes;
    }
  },
  async mounted() {
    this.getSiteIds();
    this.redAndOrangeCount = await this.fetchRedAndOrangePendingCount();
  },
  created() {
    // if (['Alerts', 'PatientList', 'PatientCreate'].includes(this.$route.name)) {
    //   this.$store.dispatch('alerts/getAlertCount')
    // }

    this.setAccountItems();
    this.$app.eventBus.$on('forceLogout', this.doLogout);
    this.$app.eventBus.$on('changeLanguage', this.refresh);
  },
  beforeDestroy(){
    this.$app.eventBus.$off('forceLogout', this.doLogout)
    this.$app.eventBus.$on('changeLanguage', this.refresh);
  },
}
</script>

<style lang="scss">
// mobile first
.c-main-header__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  margin-left: -12px;
  margin-right: -12px;
  border-bottom: 1px solid #d6dbe4;
  flex-wrap: wrap;
}

.c-main-header__right,
.c-main-header__left {
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
}

.c-main-header__logo {
  display: flex;
  align-items: flex-start;
  margin-right: 38px;
}

.c-main-header__icon {
  margin-right: 17px;
  height: 28px;
}

.c-main-header__menu {
  display: flex;

  li {
    list-style: none;
    margin-right: 10px;
    max-height: 36px;
  }

  i {
    margin: 0.3em 0;
  }

  a {
    line-height: 1.4em;
  }
}

.c-main-header__search-patients {
  width: 100%;
}

.c-main-header__menu-alert-count {
  vertical-align: super;
  font-size: 0.8rem;
}

.c-main-header__title {
  display: flex;
  align-items: center;
  margin-right: 38px;

  h3 {
    white-space: nowrap;
  }
}

// mobile screens

// tablet screens
.v-application.md-up {
  .c-main-header__row {
    padding: 12px 24px 12px 30px;
  }

  .c-main-header__right,
  .c-main-header__left {
    margin-top: 12px;
    margin-bottom: 12px;
  }

  .c-main-header__menu {
    li {
      margin-right: 1em;
      margin-top: 10px;
      max-height: unset;
    }
  }

  .c-main-header__search-patients {
    max-width: 340px;
    position: static;
  }

  .c-main-header__icon {
    height: 38px;
  }
}

// desktop/large screens
.v-application.lg-up {
  .c-main-header__menu {
    li {
      margin-right: 2.4em;
    }
  }
}

// -------------------------------------------------- BEM modifiers ------------------------------------------------
</style>
